import React from 'react';
import BaseSelect from '@material-ui/core/Select';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { FormHelperText, Grid, InputLabel, MenuItem } from '@material-ui/core';

import { TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../enum/formProps';
import './MultiSelect.scss';

interface MultiSelectProps {
  label: string;
  name: string;
  choices: {
    value: string;
    key: string | number;
  }[];
  color?: TEXT_FIELD_COLOR;
  variant?: TEXT_FIELD_VARIANT;
}

const MultiSelect: React.FC<MultiSelectProps> = ({ label, ...props }) => {
  const { t } = useTranslation();
  const [field, meta] = useField(props);
  const isError = !!(meta.error && meta.touched);

  return (
    <Grid container spacing={0} className="MultiSelect-Container">
      <Grid item xs={4} md={3} lg={2} xl={1}>
        <InputLabel className="MultiSelect-InputLabel" id={props.name} error={isError}>
          {t(label)}
        </InputLabel>
      </Grid>
      <Grid item xs={8} md={9} lg={10} xl={11}>
        <BaseSelect
          className="MultiSelect-BaseSelect"
          error={isError}
          fullWidth
          multiple
          color={props.color}
          labelId={props.name}
          id={props.name}
          {...field}
          {...props}
        >
          {props.choices.map(({ key, value }) => (
            <MenuItem value={key} key={key}>
              {value}
            </MenuItem>
          ))}
        </BaseSelect>
        <FormHelperText error={isError}>{t(meta.error ? meta.error : '')}</FormHelperText>
      </Grid>
    </Grid>
  );
};

export default MultiSelect;
